import React from 'react';
import {Grid} from "@mui/material";
import Timeline from "../../TimeLine/Timeline";


function OurHistory() {

    return <>
        <Grid container direction={'column'} style={{justifyContent: "center", alignItems: "center"}}>
            <Timeline/>
        </Grid>

    </>

}

export default OurHistory;